import apiFetch from '../apiFetch'

export default function (token, sourceChannelId) {
  return apiFetch({ endPoint: `SourceChannel/${sourceChannelId}`, method: 'DELETE', token: token })
}
